import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { initErrorReporter } from "@/lib/errorReporter";
import { installHttpProgress } from "@/lib/httpProgressBoot";

// Error Monitor — envia crashes JS + falhas de API para o backend
// (POST /api/errors/report). Painel admin: RASCUNHOS → ERROS.
initErrorReporter();

// TopProgressBar (Ago/2026) — regista axios/fetch interceptors para mostrar
// barra de progresso automática em cada request HTTP.
installHttpProgress();

// Força tema dark permanentemente (Rugged Cinematic). Botão de toggle removido.
(() => {
  try {
    localStorage.setItem('tectur.theme', 'dark');
    document.documentElement.classList.add('dark');
  } catch {
    document.documentElement.classList.add('dark');
  }
})();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register Service Worker for offline functionality
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('Service Worker registered:', registration.scope);
      })
      .catch((error) => {
        console.error('Service Worker registration failed:', error);
      });
  });
}
